import { useQuery } from "@tanstack/react-query";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { projectConnectionMutations } from "@/queries/project-connections/mutations";
import { useProjectConnectionQueries } from "@/queries/project-connections/queryOptions";

import { ProjectConnectionsList, type ProjectConnectionsListProps } from "./ProjectConnectionsList";

export function ListConnectionsPage(): React.ReactNode {
  const projectConnectionQueries = useProjectConnectionQueries();

  const connectionsQuery = { Limit: 1000, Offset: 0, IncludeAllFromProfile: true };
  const {
    data: connections,
    isFetching: isFetchingConnections,
    error: connectionsError,
  } = useQuery(projectConnectionQueries.list(connectionsQuery));

  const deleteProjectConnection = projectConnectionMutations.useDeleteProjectConnection();

  const error = connectionsError;
  if (error) {
    return <ErrorPage error={error} />;
  }

  const contentProps: ProjectConnectionsListProps = {
    connections: connections?.items ?? [],
    onDelete: deleteProjectConnection.mutateAsync,
    isLoading: isFetchingConnections,
  };

  return <ProjectConnectionsList {...contentProps} />;
}
